import logoIMG from '@/assets/imgs/brand/logo.png';
import { Image } from '@/components/generic';
import { Link } from 'react-router-dom';

type LogoProps = {
  className?: string;
};

export const Logo = ({ className }: LogoProps) => {
  return (
    <Link className={`block w-12 h-12 ${className || ''}`} to='/'>
      <Image
        className='size-full opacity-100 dark:!hidden'
        src={logoIMG}
        alt='logo'
        style={{ width: '48px', height: '48px' }}
      />
      <Image
        className='size-full !hidden opacity-100 dark:!block'
        src={logoIMG}
        alt='logo'
        style={{ width: '48px', height: '48px' }}
      />
    </Link>
  );
};
